import { Typography } from 'antd';
import { SchedulingJob } from '../scheduleApi';

const { Text } = Typography;

type Props = {
  job: SchedulingJob;
};

const JobDragOverlay = ({ job }: Props) => {
  const jobAddressParts = [
    job.address1,
    job.city,
    job.state,
  ].filter(Boolean);
  const jobAddress = jobAddressParts.join(', ');

  return (
    <div
      style={{
        padding: '12px',
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        border: '1px solid #d9d9d9',
        width: '280px',
        cursor: 'grabbing',
      }}
    >
      <div>
        <Text strong>{job.jobName}</Text>
      </div>
      <div>
        <Text type="secondary" style={{ fontSize: '12px' }}>
          {jobAddress}
        </Text>
      </div>
    </div>
  );
};

export default JobDragOverlay;
